import { jsxs, jsx } from "react/jsx-runtime";
import { useContext } from "react";
import assert from "assert";
import { Box } from "../../Box/Box.mjs";
import { useMenuItem } from "../../MenuItem/useMenuItem.mjs";
import { StepContext, StepperContext } from "../../Stepper/StepperContext.mjs";
import { StepIndicator } from "../../Stepper/Step.mjs";
import { indicatorContainer, step, tone, focusOverlay } from "../../Stepper/Stepper.css.mjs";
import { FieldOverlay } from "../FieldOverlay/FieldOverlay.mjs";
const MenuItemStepper = ({ id, label, complete = false, data }) => {
  const { stepNumber } = useContext(StepContext);
  const stepperContext = useContext(StepperContext);
  assert(
    stepperContext !== null,
    "A MenuItemStepper must be rendered as a child of a Stepper. See the documentation for correct usage: https://design-system.machobear.ca"
  );
  const { activeStep, progress, isLinear, onStepClick, tone: stepperTone } = stepperContext;
  const active = activeStep === stepNumber;
  const linearStepBeforeProgress = isLinear && stepNumber < progress;
  const completed = complete || linearStepBeforeProgress;
  const started = active || complete || isLinear && stepNumber <= progress;
  const interactable = typeof onStepClick === "function" && !active && (!isLinear || stepNumber <= progress);
  const { menuItemProps, MenuItemChildren } = useMenuItem({
    onClick: () => {
      if (interactable && !active) {
        onStepClick == null ? void 0 : onStepClick({ stepNumber });
      }
    },
    formElement: true,
    data,
    id
  });
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...menuItemProps,
      "aria-checked": completed,
      role: "menuitemstepper",
      component: "button",
      type: "button",
      display: "flex",
      alignItems: "center",
      gap: "xsmall",
      children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            display: "block",
            position: "relative",
            transition: "fast",
            "aria-hidden": true,
            className: [indicatorContainer, step, tone[stepperTone]],
            children: [
              /* @__PURE__ */ jsx(
                FieldOverlay,
                {
                  variant: "focus",
                  borderRadius: "full",
                  onlyVisibleForKeyboardNavigation: true,
                  className: focusOverlay
                }
              ),
              /* @__PURE__ */ jsx(StepIndicator, { complete: completed, active, started })
            ]
          }
        ),
        /* @__PURE__ */ jsx(MenuItemChildren, { tone: void 0, icon: void 0, badge: void 0, formElement: true, children: label })
      ]
    }
  );
};
MenuItemStepper.__isMenuItem__ = true;
export {
  MenuItemStepper
};
